export const projectsData = {
  header: {
    badge: {
      text: "Our Portfolio",
      icon: "BusinessIcon"
    },
    title: "Recently Inspected Projects",
    description: "Discover the diverse range of residential projects we've successfully inspected across Mumbai, Pune and Bangalore. Each project represents our commitment to quality and thoroughness."
  },
  scrollHint: {
    text: "Swipe to explore more projects",
    icon: "SwipeIcon"
  },
  projects: [
    {
      projectName: 'Espada at Life Republic',
      location: 'Hinjewadi, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/espada_at_life_republic_by_kolte_patil_hinjewadi_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Austin Lush',
      location: 'Tathawade, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/austin_lush_tathawade_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    }
    ,
    {
      projectName: 'The Address by GS',
      location: 'Thane, Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/the_address_by_gs_thane_mumbai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'New Ambivali Society',
      location: 'Andheri, Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/new_ambivali_society_andheri_mumbai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Sowparnika Indradhanush',
      location: 'Hoskote, Bangalore',
      image: 'https://cdn.snageasy.in/app-img/webp/sowparnika_indradhanush_hoskote_bangalore.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Adarsh Palm Acres',
      location: 'Bagalur, Bangalore',
      image: 'https://cdn.snageasy.in/app-img/webp/adarsh_palm_acres_bagalur_bangalore.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Prestige Courtyards',
      location: 'Sholinganallur, Chennai',
      image: 'https://cdn.snageasy.in/app-img/webp/prestige_courtyards_sholinganallur_chennai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Renuka Panchtatva',
      location: 'Tathawade, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/renuka_panchtatva_tathawade_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Casagrand Flamingo',
      location: 'HSR Layout, Bangalore',
      image: 'https://cdn.snageasy.in/app-img/webp/casagrand_flamingo_hsr_layout_bangalore.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Casagrand Tudor',
      location: 'Mogappair, Chennai',
      image: 'https://cdn.snageasy.in/app-img/webp/casagrand_tudor_mogappair_chennai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Appaswamy Alteeza',
      location: 'Perungudi, Chennai',
      image: 'https://cdn.snageasy.in/app-img/webp/appaswamy_alteeza_perungudi_chennai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Adani Atelier Greens',
      location: 'Mundhwa, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/adani_atelier_greens_mundhwa_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Godrej Boulevard',
      location: 'Manjri, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/godrej_boulevard_manjri_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Ajmera Lakeside Paradise',
      location: 'Yelahanka, Bangalore',
      image: 'https://cdn.snageasy.in/app-img/webp/ajmera_lakeside_paradise_yelahanka_bangalore.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Casagrand Savoye',
      location: 'Thoraipakkam, Chennai',
      image: 'https://cdn.snageasy.in/app-img/webp/casagrand_savoye_thoraipakkam_chennai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Kumar Prospera',
      location: 'Hadapsar, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/kumar_prospera_hadapsar_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Ratnadeep Heights',
      location: 'Kurla, Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/ratnadeep_heights_kurla_mumbai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Mangalam Melizma',
      location: 'Kotwal Nagar, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/mangalam_melizma_kotwal_nagar_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Ramky Fortuna',
      location: 'Whitefield, Bangalore',
      image: 'https://cdn.snageasy.in/app-img/webp/ramky_fortuna_whitefield_bangalore.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Casagrand Vivant',
      location: 'Kolapakkam, Chennai',
      image: 'https://cdn.snageasy.in/app-img/webp/casagrand_vivant_kolapakkam_chennai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Casagrand ECR 14',
      location: 'ECR, Chennai',
      image: 'https://cdn.snageasy.in/app-img/webp/casagrand_ecr14_ecr_chennai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Solitaire World',
      location: 'Bibwewadi, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/solitaire_world_bibwewadi_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Viraj Heights',
      location: 'Thane, Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/viraj_heights_thane_mumbai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Sujan',
      location: 'Thane, Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/sujan_thane_mumbai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Sai Shakti Park',
      location: 'Wagholi, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/sai_shakti_park_wagholi_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'SMR Vinay Estella',
      location: 'Vidyaranyapura, Bangalore',
      image: 'https://cdn.snageasy.in/app-img/webp/smr_vinay_estella_vidyaranyapura_bangalore.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'ANP Universe',
      location: 'Balewadi, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/anp_universe_balewadi_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Shraddha Classic',
      location: 'Bhandup, Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/shraddha_clasic_bhandup_mumbai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Sudarshan Paradise',
      location: 'Pimple Nilakh, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/sudarshan_paradise_pimple_nilakh_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Samarth County',
      location: 'Ravet, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/samarth_county_ravet_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Satin Brick',
      location: 'Kharadi, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/satin_brick_kharadi_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Aashrayaa EcoCity',
      location: 'Hoskote, Bangalore',
      image: 'https://cdn.snageasy.in/app-img/webp/aashrayaa_ecocity_hoskot_bangalore.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Assetz Canvas and Cove',
      location: 'Begur, Bangalore',
      image: 'https://cdn.snageasy.in/app-img/webp/assetz_canvas_and_cove_begur_bangalore.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Blue Ridge',
      location: 'Hinjewadi, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/blueridge_hinjewadi_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Applaud 38',
      location: 'Goregaon, Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/applaud_38_goregaon_mumbai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Paradigm Antalya',
      location: 'Jogeshwari, Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/paradigm_antalya_jogeshwari_mumbai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Ahilyadevi Society Row House',
      location: 'Baner, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/row_house_ahilyadevi_society_baner_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Grand Lavasa',
      location: 'Chandapura, Bangalore',
      image: 'https://cdn.snageasy.in/app-img/webp/grand_lavasa_chandapura_bangalore.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'La Mer Regency',
      location: 'Panvel, Navi Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/la_mer_regency_panvel_navi_mumbai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Runwal Central Park',
      location: 'Pimpri-Chinchwad, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/runwal_central_park_pimpri_chinchwad_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Grand Stella',
      location: 'Vartak Nagar, Thane',
      image: 'https://cdn.snageasy.in/app-img/webp/grand_stella_vartak_nagar_thane_mumbai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Lodha Stella',
      location: 'Thane, Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/lodha_stella_thane_mumbai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Rohan Viti',
      location: 'Wakad, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/rohan_viti_wakad_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Rohan Abhilasha 3',
      location: 'Wagholi, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/rohan_abhilasha_3_wagholi_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Dosti Mezzo',
      location: 'Sion, Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/dosti_mezzo_sion_mumbai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Abhee Riviera Royal',
      location: 'VGP Layout, Bangalore',
      image: 'https://cdn.snageasy.in/app-img/webp/abhee_riviera_royale_vgp_layout_bangalore.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Mantra Mirari',
      location: 'Mundhwa, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/mantra_mirari_mundhwa_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Kalpataru Eternia',
      location: 'Thane, Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/kalpataru_eternia_thane_mumbai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Prestige City',
      location: 'Bangalore',
      image: 'https://cdn.snageasy.in/app-img/webp/prestige_city_bangalore.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Arihant Aspire',
      location: 'Panvel, Navi Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/arihant_aspire_panvel_navi_mumbai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Unique Que 914',
      location: 'Keshav Nagar, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/unique_que_914_keshav_nagar_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Mayfair Gardens',
      location: 'Virar, Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/unique_que_914_keshav_nagar_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: '7 Plumeria Drive',
      location: 'Punawale, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/7_plumeria_drive_punawale_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Reelicon Claramount',
      location: 'Parvati Market Yard, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/reelicon_claramount_parvati_market_yard_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Larkins Nest',
      location: 'Kasarvadavali, Thane, Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/larkins_nest_kasarvadavali_thane_mumbai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Kumar PARC Residences',
      location: 'Hadapsar, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/kumar_parc_residences_hadapsar_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Rustomjee Crown',
      location: 'Prabhadevi, Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/rustomjee_crown_prabhadevi_mumbai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'The Views At Adani Realty',
      location: 'Ghatkopar, Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/the_views_adani_realty_ghatkopar_mumbai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Sheth Montana',
      location: 'Mulund, Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/sheth_montana_mulund_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Dosti Tulip',
      location: 'Thane, Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/dosti_tulip_thane_mumbai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Lodha Bella Vita',
      location: 'NIBM, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/lodha_bella_vita_nibm_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Vision Vanessa',
      location: 'Ravet, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/vision_vanessa_ravet_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Puranik Rumah Bali',
      location: 'Thane, Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/puranik_rumah_bali_thane_mumbai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Little Earth',
      location: 'Ravet, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/littile_earth_ravet_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'K Town',
      location: 'Kiwale, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/k_town_kiwale_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Piramal Vaikunth',
      location: 'Thane, Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/piramal_vaikunth_thane_mumbai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Kohinoor Eden',
      location: 'Kalyan, Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/kohinoor_eden_kalyan_mumbai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Newton Homes',
      location: 'Hadapsar, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/newton_homes_hadapsar_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Reelicon Claramount',
      location: 'Parvati Market Yard, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/reelicon_claramount_parvati_market_yard_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Piramal Aranya',
      location: 'Byculla, Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/piramal_aranya_byculla_mumbai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Pride World City',
      location: 'Lohegaon, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/pride_world_city_lohegaon_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Godrej 24',
      location: 'Hinjewadi, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/godrej_24_hinjewadi_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Shlok',
      location: 'Moshi, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/shlok_moshi_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Veena Synergy',
      location: 'Andheri, Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/veena_synergy_andheri_mumbai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Laxmi Empire',
      location: 'Ravet, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/laxmi_empire_ravet_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Jeevan\'s Octave',
      location: 'Seegehalli, Bangalore',
      image: 'https://cdn.snageasy.in/app-img/webp/jeevan_s_octave_seegehalli_bangalore.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Prestige Siesta',
      location: 'Mulund, Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/prestige_siesta_mulund_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Regency Palms',
      location: 'Nerul, Navi Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/regency_palms_nerul_navi_mumbai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Today Anandam',
      location: 'Upper Kharghar, Navi Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/today_anandam_upper_kharghar_navi_mumbai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Rustomjee Bella',
      location: 'Bhandup, Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/rustomjee_bella_bhandup_mumbai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Gami Tiara',
      location: 'Panvel, Navi Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/gami_tiara_panvel_navi_mumbai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Assetz Sun & Sanctum',
      location: 'Battarahalli, Bangalore',
      image: 'https://cdn.snageasy.in/app-img/webp/assetz_sun_and_sanctum_battarahalli_bangalore.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Siddha Sky',
      location: 'Wadala, Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/siddha_sky_wadala_mumbai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Mantri Lithos Penthouse',
      location: 'Thanisandra, Bangalore',
      image: 'https://cdn.snageasy.in/app-img/webp/mantri_lithos_penthouse_thanisandra_bangalore.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Pristine Equilife',
      location: 'Mahalunge, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/pristine_equilife_homes_mahalunge_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'DSR Woodwinds',
      location: 'Sarjapur, Bangalore',
      image: 'https://cdn.snageasy.in/app-img/webp/dsr_woodwinds_sarjapur_bangalore.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'MICL Aaradhya Parkwood',
      location: 'Mira Road, Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/micl_aaradhya_parkwood_mira_road_mumbai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Lodha Woods',
      location: 'Kandivali, Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/lodha_woods_kandivali_mumbai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Arihant Alishan Clan',
      location: 'Kharghar, Navi Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/arihant_alishan_clan_kharghar_navi_mumbai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'VTP Sierra',
      location: 'Baner, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/vtp_sierra_baner_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Zen Elite',
      location: 'Kharadi, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/zen_elite_kharadi_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Ecolife Eon Akash',
      location: 'Varthur, Bangalore',
      image: 'https://cdn.snageasy.in/app-img/webp/ecolife_eon_akash_varthur_bangalore.webp',
      status: 'Completed',
      units: '450+',
      category: 'Residential'
    },
    {
      projectName: 'Shapoorji Pallonji Joyville Spectra',
      location: 'Hinjewadi, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/shapoorji_palonjee_joyville_spectra_hinjewadi_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Vision Altia',
      location: 'Ravet, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/vision_altia_ravet_pune.webp',
      status: 'Completed',
      units: '450+',
      category: 'Residential'
    },
    {
      projectName: 'S2 Avenues',
      location: 'Sarjapur, Bangalore',
      image: 'https://cdn.snageasy.in/app-img/webp/s2_avenues_sarjapur_bangalore.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Ashar Arize',
      location: 'Kalwa, Thane, Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/ashar_arize_kalwa_thane_mumbai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Megapolis Mystic',
      location: 'Hinjewadi, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/megapolis_mystic_hinjewadi_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Gera planet of Joy',
      location: 'Kharadi, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/gera_planet_of_joy_kharadi_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Riverdale Grove',
      location: 'Kharadi, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/riverdale_grove_kharadi_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Life Republic R13 Aros',
      location: 'Hinjewadi, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/life_republic_r13_aros_hinjewadi_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: '24K Sareno',
      location: 'Baner, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/24k_sereno_baner_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Saritha Serene',
      location: 'Gunjar, Bangalore',
      image: 'https://cdn.snageasy.in/app-img/webp/saritha_serene_gunjur_bangalore.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Sheth Avante',
      location: 'Kanjurmarg, Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/sheth_avante_kanjurmarg_mumbai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Sai World City',
      location: 'Panvel, Navi Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/sai_world_city_panavel_navi_mumbai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Haware Intelligentia',
      location: 'Thane, Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/haware_intelligentia_thane_mumbai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Sahyadri CHS Pandurangwadi',
      location: 'Goregaon, Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/sahyadri_chs_pandurangwadi_goregoan_mumbai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Sattva Kings Domain',
      location: 'Indiranagar, Bangalore',
      image: 'https://cdn.snageasy.in/app-img/webp/sattva_kings_domain_indiranagar_bangalore.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Kohinoor Abhiman',
      location: 'Shirgaon, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/kohinoor_abhiman_shirgaon_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Brooklyn Pride World City',
      location: 'Pimpri Chinchwad, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/brooklyn_pride_world_city_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Top Tower',
      location: 'Wakad, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/top_tower_wakad_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential Residential'
    },
    {
      projectName: 'Eastern Rever Residency',
      location: 'Pimple Saudagar, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/eastern_river_residency_pimple_soudagar_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Godrej Hill Retreat',
      location: 'Mahalunge, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/godrej_hill_retreat_mahalunge_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Dem Phoenix',
      location: 'Malad, Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/dem_phoenix_malad_mumbai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Assetz Marq',
      location: 'Kannamangala, Bangalore',
      image: 'https://cdn.snageasy.in/app-img/webp/assetz_marq_kannamangala_bangalore.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'GR Floret',
      location: 'Akshayanagar, Bangalore',
      image: 'https://cdn.snageasy.in/app-img/webp/gr_floret_akshayananagr_bangalore.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Prestige Shantiniketan',
      location: 'Whitefield, Bangalore',
      image: 'https://cdn.snageasy.in/app-img/webp/prestige_shantiniketan_whitefield_bangalore.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Vaarivana Villas',
      location: 'Urse, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/vaarivana_villas_urse_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Raymond 10X',
      location: 'Thane, Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/raymond_10x_thane_mumbai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Visoka Keystone',
      location: 'Tathawade, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/visoka_keystone_tathawade_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Nandan Ace',
      location: 'Balewadi, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/nandan_ace_balewadi_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'L&T Rejuve 360',
      location: 'Mulund, Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/l_and_t_rejuve_360_mulund_mumbai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Mahavir Exotique',
      location: 'Kharghar, Navi Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/mahavir_exotique_kharghar_navi_mumbai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Prima Imperia',
      location: 'Ravet, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/prima_imperia_ravet_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Majestique Marbella',
      location: 'Kharadi, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/majestique_marbella_kharadi_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Ceratec Presidential Towers',
      location: 'Ravet, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/ceratec_presidential_towers_ravet_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Cross Town at One',
      location: 'Kalyan, Thane',
      image: 'https://cdn.snageasy.in/app-img/webp/cross_town_at_one_kalyan_thane.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Godrej Emerald',
      location: 'Thane, Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/godrej_emerald_thane.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'MJ Opera',
      location: 'Wakad, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/mj_opera_wakad_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Jeevan Octave',
      location: 'Seegehalli, Bangalore',
      image: 'https://cdn.snageasy.in/app-img/webp/jeevan_octave_seegehalli_bangalore.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Bhartiya Centre For Information Technology',
      location: 'Bangalore, Karnataka',
      image: 'https://cdn.snageasy.in/app-img/webp/bhartiya_centre_for_information_technology_bengaluru.webp',
      status: 'Completed',
      units: '500+',
      category: 'Commercial'
    },
    {
      projectName: 'Rudraksh Enclave',
      location: 'Boriwali, Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/rudraksh_enclave_borivali_mumbai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Felicity',
      location: 'Pune, Maharashtra',
      image: 'https://cdn.snageasy.in/app-img/webp/felicity_ravet_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'VTP Beaumonde',
      location: 'Manjari, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/vtp_beaumonde_manjari_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Gagan Unnati',
      location: 'Kondhwa, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/gagan_unnati_kondhwa_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Embassy One',
      location: 'Thane, Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/embassy_one_thane_mumbai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'My Home',
      location: 'Wakad, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/my_home_wakad_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Dosti Eastern Stay',
      location: 'Wadala, Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/dosti_eastern_stay_wadala_mumbai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Sukhwani Kingsley',
      location: 'Thergaon, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/sukhwani_kingsley_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Kamalraj Athens',
      location: 'Wakad, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/kamalraj_athens_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Sai Aura',
      location: 'Pimple Saudagar, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/sai_aura_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Om Mangalam Disha',
      location: 'Pimpri Chinchwad, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/om_mangalam_by_disha_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Skyi PWC Towers',
      location: 'Bavdhan, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/pwc_towers_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Unique Youtopia',
      location: 'Kharadi, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/unique_youtopia_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Kohinoor Shangrila',
      location: 'Pimpri, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/kohinoor_shangrila_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Radiance Gardenia',
      location: 'Hennur, Bangalore',
      image: 'https://cdn.snageasy.in/app-img/webp/radiance_gardenia_bengaluru.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Regency Luxuria',
      location: 'Dombivli, Thane',
      image: 'https://cdn.snageasy.in/app-img/webp/regency_luxuria_thane.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'KhushVista',
      location: 'Nyati Estate, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/khush_vista_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Hillcrest',
      location: 'Pimple Saudagar, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/hillcrest_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Surya Skies',
      location: 'Punawale, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/surya_skies_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    }, 
    {
      projectName: 'Auris Serenity',
      location: 'Malad, Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/auris_serenity_malad.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    {
      projectName: 'Kundan Altura',
      location: 'Pimpri Chinchwad, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/kundan_altura_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    { 
      projectName: 'Gera\'s World of Joy Child Centric Homes', 
      location: 'Kharadi, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/gera_world_of_joy_child_centric_homes.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    { 
      projectName: 'Atharshi', 
      location: 'Bhugaon, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/atharshi_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    }, 
    { 
      projectName: 'Kalpataru Magnus', 
      location: 'Bandra, Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/kalpataru_magnus.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    { 
      projectName: 'Sound of Soul by Kolte Patil', 
      location: 'Hinjewadi, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/sound_of_soul_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    { 
      projectName: 'Today Anandam', 
      location: 'Kharghar, Navi Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/today_anandam.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    { 
      projectName: 'Bhagwati Belleza', 
      location: 'Ulwe, Navi Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/bhagwati_belleza.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    { 
      projectName: 'Kohinoor Sportsville', 
      location: 'Hinjewadi, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/kohinoor_sportsville.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    { 
      projectName: 'Elixir Reserve (L & T)', 
      location: 'Powai, Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/Elixir_Reserve_Powai.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    { 
      projectName: 'Runwal Gardens', 
      location: 'Dombivli, Thane',
      image: 'https://cdn.snageasy.in/app-img/webp/runwal_garden.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    { 
      projectName: 'Ashiyana Malhar', 
      location: 'Marunji, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/ashiyana_malhar.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    { 
      projectName: 'Lodha Amara', 
      location: 'Kolshet, Thane',
      image: 'https://cdn.snageasy.in/app-img/webp/lodha_amara.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    { 
      projectName: 'Advitya Prathamesh Park', 
      location: 'Baner, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/advitya_pune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    { 
      projectName: 'Kalpataru Elitus', 
      location: 'Mulund, Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/kalpataru_elitus.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    { 
      projectName: 'Shubh Nirvana', 
      location: 'Viman Nagar, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/shubhnirvanapune.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    { 
      projectName: 'Marathon Nexzone', 
      location: 'Panvel, Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/MarathonNexzone.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    { 
      projectName: 'Kiya Homes Around the Life', 
      location: 'Whitefield, Bangalore',
      image: 'https://cdn.snageasy.in/app-img/webp/kiyahomes.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    { 
      projectName: 'EON Homes', 
      location: 'Hinjewadi, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/EonHomes.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    { 
      projectName: 'Puranic City Reserva', 
      location: 'Thane, Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/PURANIKS%20CITY%20RESERVA.webp',
      status: 'Completed',
      units: '500+',
      category: 'Residential'
    },
    { 
      projectName: 'Opus76', 
      location: 'Wakad, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/Opus76.webp',
      status: 'Completed',
      units: '300+',
      category: 'Residential'
    },
    { 
      projectName: 'Ashar Aria', 
      location: 'Thane, Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/AsharAria.webp',
      status: 'Completed',
      units: '400+',
      category: 'Residential'
    },
    { 
      projectName: 'Western Avenue', 
      location: 'Wakad, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/WesternAvenue.webp',
      status: 'Completed',
      units: '250+',
      category: 'Residential'
    },
    { 
      projectName: 'Apostrophe', 
      location: 'Hinjewadi, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/ApostrophePune.webp',
      status: 'Completed',
      units: '350+',
      category: 'Residential'
    },
    { 
      projectName: 'Tinsel County', 
      location: 'Hinjewadi, Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/TinselCountyPune.webp',
      status: 'Completed',
      units: '600+',
      category: 'Residential'
    },
    { 
      projectName: 'Ajmera Greenfinity', 
      location: 'Wadala, Mumbai',
      image: 'https://cdn.snageasy.in/app-img/webp/Ajmera%20Greenfinity%20wadala.webp',
      status: 'Completed',
      units: '800+',
      category: 'Residential'
    },
    { 
      projectName: 'Gera Evolve', 
      location: 'Pune',
      image: 'https://cdn.snageasy.in/app-img/webp/Gera%20Evolve%20Pune.webp',
      status: 'Completed',
      units: '450+',
      category: 'Residential'
    },
    { 
      projectName: "Gera's World Of Joy", 
      location: 'Pune',
      image: "https://cdn.snageasy.in/app-img/webp/Gera's%20World%20Of%20Joy%20Pune.webp",
      status: 'Completed',
      units: '700+',
      category: 'Residential'
    }
  ],
  cta: {
    badge: {
      text: "Join Our Success Stories",
      icon: "CheckCircleIcon"
    },
    title: "Ready to Add Your Project to Our Portfolio?",
    description: "Join hundreds of satisfied clients who trust SnagEasy for their home inspection needs. Let us help you ensure a flawless possession experience.",
    stats: [
      {
        number: "1300+",
        label: "Projects Inspected"
      },
      {
        number: "100%",
        label: "Client Satisfaction"
      },
      {
        number: "24hrs",
        label: "Report Delivery"
      }
    ],
    button: {
      text: "Quick Free Consultation",
      icon: "CheckCircleIcon"
    }
  }
};
